export const MANAGER_LOCATION_DETAILS_BREADCRUMBS = [
  { id: "/", name: "Home" },
  { id: "/clients", name: "Clients" },
  { id: "/clients/:clientId", name: ":clientName" },
  { id: "/clients/locations/:id", name: ":name" },
];
